import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Are you fully insured in Ireland?",
    a: "Yes — AGS Cleaning Services holds comprehensive Public and Employer's Liability Insurance tailored for commercial and industrial cleaning operations across Ireland.",
  },
  {
    q: "Do we need to provide our own cleaning equipment and chemicals?",
    a: "No, we supply everything. Our team arrives fully equipped with professional-grade machinery and certified eco-friendly cleaning products.",
  },
  {
    q: "Can you clean outside of our business hours?",
    a: "Absolutely. We offer flexible scheduling — early mornings, evenings, or weekends — to ensure our work never interrupts your staff or operations.",
  },
  {
    q: "Do you provide RAMS documentation?",
    a: "Yes. We provide site-specific Risk Assessments and Method Statements (RAMS) before starting any contract, and all relevant operatives are fully trained for the environments they work in.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-white py-28 md:py-40 border-t border-[#E5EBF2]"
    >
      <div className="container-ags grid md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-4">
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#0E2A57]/60 font-medium">
            10 — FAQ
          </span>
          <h2 className="mt-6 font-heading font-extrabold text-4xl md:text-5xl leading-[1.02] tracking-[-0.035em] text-[#050B14]">
            Frequently <span className="italic-display font-normal text-[#0E2A57]">asked</span> questions.
          </h2>
          <p className="mt-6 text-[#475569] text-base leading-relaxed">
            Don't see your question? Send it through our quote form — we
            personally answer every enquiry within 24 hours.
          </p>
        </div>

        <div className="md:col-span-8">
          <Accordion type="single" collapsible className="border-t border-[#E5EBF2]">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#E5EBF2]"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-heading font-bold text-lg md:text-xl text-[#050B14] py-6 hover:no-underline hover:text-[#0E2A57] text-left"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#475569] text-base leading-relaxed pb-6 pr-4">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
